var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.5 7C1.5 6.17157 2.17157 5.5 3 5.5H6C6.82843 5.5 7.5 6.17157 7.5 7V14.5H1.5V7zM10.5 10C10.5 9.17157 11.1716 8.5 12 8.5H13C13.8284 8.5 14.5 9.17157 14.5 10V14.5H10.5V10z", fill: "#fff", stroke: "#303030" }),
    React.createElement("path", { d: "M5.5 3.73459C5.5 2.98812 6.04889 2.35523 6.78787 2.24967L9.78787 1.82109C10.6915 1.692 11.5 2.39319 11.5 3.30602V14.5H5.5V3.73459Z", fill: "#fff", stroke: "#303030" }),
    React.createElement("path", { stroke: "#303030", d: "M7.5 4L7.5 5M7.5 6L7.5 7M7.5 8L7.5 9M9.5 4L9.5 5M9.5 6L9.5 7M9.5 8L9.5 9" })
  );
});